import { render, staticRenderFns } from "./BarConsultationsISTByDouleursPhysiques.vue?vue&type=template&id=bdf0a184&"
import script from "./BarConsultationsISTByDouleursPhysiques.vue?vue&type=script&lang=ts&"
export * from "./BarConsultationsISTByDouleursPhysiques.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports